import { useEffect, useState } from 'react';
import { Alignments, classFromProperties, getOptionalProps, getUniqId, Paddings, Sizes } from '../../ui-helpers';
import './check-box.css';

/**
 * Check box component.
 * @param {ReactDOM.props} props Component properties
 * @returns Generated component.
 */
const CheckBox = (props) => {

    // Excluded properties for automatic properties propagation
    const Excluded = ['id', 'label', 'labelStyle', 'value', 'checked', 'unchecked', 'onClick', 'onChange', 'inline', 'before', 'disabled', 'readOnly'].concat(Alignments, Paddings, Sizes);

    // Define checked values
    let checkedValue = props?.checked === undefined ? true : props?.checked;
    let uncheckedValue = props?.unchecked === undefined ? false : props?.unchecked;

    // Initialize states
    const [ id ] = useState(props?.id ? props.id : getUniqId());
    const [ value, setValue ] = useState(props?.value);
    const [ isDisabled, setDisabled ] = useState(props?.disabled !== undefined ? props?.disabled : false);
    const [ isReadOnly, setReadOnly ] = useState(props?.readOnly !== undefined ? props?.readOnly : false);
    
    /**
     * Handles check box click.
     * @param {ClickEvent} evt Click event.
     */
    const handleClick = (evt) => {
        // Check readonly
        if (props?.readOnly) return;

        // Update value
        const newValue = value === checkedValue ? uncheckedValue : checkedValue;
        setValue(newValue);
        evt.target.checked = newValue === checkedValue;
        evt.target.value = newValue;
        props?.onChange?.(evt, newValue);
    }

    /**
     * Handles value change from properties.
     */
    useEffect(() => {
        setValue(props?.value);
        setDisabled(props?.disabled !== undefined ? props?.disabled : false);
        setReadOnly(props?.readOnly !== undefined ? props?.readOnly : false);
    }, [props?.value, props?.disabled, props?.readOnly]);

    // Render component
    return (
        <div 
            id={id}
            className={classFromProperties(
                props,
                'check-box' +
                    (isDisabled ? ' disabled' : '') +
                    (isReadOnly ? ' readOnly' : '') +
                    (value === checkedValue ? ' checked' : ''),
                Alignments,
                Paddings,
                Sizes,
                ['inline', 'before', 'checked', 'unchecked']
            )}
            onClick={handleClick}
            {...getOptionalProps(props, Excluded)}
            tabIndex={isDisabled ? '-1' : '0'}
        >
            {props?.label ? <label style={props?.labelStyle}>{props.label}</label> : <></>}
            <div className='checkbox-container'>
                {value === checkedValue && (
                    <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                )}
            </div>
        </div>
    )
}

export default CheckBox;